// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"ResultDeal_iconSync__fSlKB","fa-spin":"ResultDeal_fa-spin__1GsrR","iconInfo":"ResultDeal_iconInfo__33HQk"};